import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useAuthDialog } from '../contexts/AuthDialogContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  const { isAuthenticated, user, isLoading } = useAuth();
  const { openAuthDialog } = useAuthDialog();
  const location = useLocation();

  console.log('ProtectedRoute:', { isAuthenticated, user, requiredRole, location });

  if (isLoading) {
    return <div>Загрузка...</div>;
  }

  if (!isAuthenticated) {
    console.log('Not authenticated, opening auth dialog');
    openAuthDialog('login');
    return <Navigate to="/" replace />;
  }

  if (requiredRole && user?.role !== requiredRole) {
    console.log('User does not have required role, redirecting to home');
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}; 